import request from '@apps-common/js-client/api/request';
import {PDA_ADMIN_V1_BASE_PATH as base} from '@account/config';

// Quota reservations (reserved AOIs) for a workspace product access.
//
// Endpoint lives at /public/quota-reservations/ in pda-admin; in live it's
// fronted under the account/ gateway prefix, same as product-access — so we use
// `base` (account/v1 in live/next, public in edition/local), matching how
// allocate/extend/adjust-quota resolve.
//
// The list is filterable by `product_id` (the API field name — NOT the DB column
// `product_access_id`). Each result: {id, collection_id, aoi_ref, product_id,
// state, amount, created_at, updated_at}. There is no geometry in the response;
// callers resolve aoi_ref -> geometry via the Granero features API.
//
// State is filtered client-side (only `reserved` is a live reservation): the
// list endpoint only wires product_id/collection_id/aoi_ref as query filters.
export const getQuotaReservations = ({
  productAccessId,
  collectionId,
  limit = 25,
  offset = 0,
  fields,
} = {}) =>
  request
    .get(`${base}/quota-reservations/`, {
      params: {
        product_id: productAccessId,
        collection_id: collectionId,
        limit,
        offset,
        ...(fields && {fields}),
      },
    })
    .then(res => res.data);

// Cheap count-only helper: reads meta.count without pulling rows.
export const getReservationCount = ({productAccessId, collectionId} = {}) =>
  getQuotaReservations({productAccessId, collectionId, limit: 1}).then(
    data => data?.meta?.count ?? 0
  );
